export default {
  'role-delegation': {
    'role-delegation': {
      actions: {
        add: true,
        edit: true,
        delete: true
      }
    }
  },
  reports: {
    reports: {
      actions: {
        download: true
      }
    }
  }
};
